import { NOISE_MODELS_MAP } from "./noiseModelsMap.js";
export const getNoiseModelForRow = (row) => {
  if (!row.noise || !row.noise.model || !NOISE_MODELS_MAP[row.noise.model]) {
    return "";
  }
  return NOISE_MODELS_MAP[row.noise.model];
};
